import { useState } from 'react';
import { useNavigate } from 'react-router';
import { TruckIcon, ShoppingCartIcon, CurrencyDollarIcon, DevicePhoneMobileIcon, CpuChipIcon, ClipboardDocumentIcon, CreditCardIcon, ClipboardDocumentListIcon, HomeModernIcon, UserGroupIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import logo from "../assets/logoNA.svg";
import log from "../assets/carousel1.jpg"

export default function Home() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const Navigate = useNavigate()

    // const MilkBottleIcon = () => (
    //     <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24">
    //       <path fill="currentColor" d="M12 2C9.79 2 8 3.79 8 6v1h2V6c0-1.1.9-2 2-2s2 .9 2 2v4.8c-1.2.4-2 1.5-2 2.8v8h6v-8c0-1.3-.8-2.4-2-2.8V6c0-2.21-1.79-4-4-4zm-2 14v4h4v-4h-4z"/>
    //     </svg>
    // );

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-900 via-sky-500 to-white">
            <nav className="fixed w-full bg-white/90 backdrop-blur-lg shadow-lg z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-20"> {/* Increased height */}
                        <div className="flex-shrink-0 flex items-center space-x-3">
                        <div className="relative w-16 h-16">
                                <img src={logo} alt='' />
                            </div>
                            <a href='/' className="text-3xl p-0 m-0 font-bold bg-gradient-to-r from-blue-900 to-sky-600 bg-clip-text text-transparent no-underline leading-tight pb-1">
                                NexusAgents
                            </a>
                        </div>

                        {/* Desktop Menu - Increased text size */}
                        <div className="hidden md:flex space-x-8">
                            <a href="services" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Services</a>
                            <a href="how" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">How It Works</a>
                            <a href="contact" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Contact</a>
                        </div>
                        {/* <a href="login" className="hidden md:flex bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a>
                        <a href="login" className="md:hidden bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a> */}

                        {/* Mobile Menu Button - Larger size */}
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="md:hidden p-3 rounded-lg text-blue-900 hover:bg-sky-50"
                        >
                            <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Menu - Larger text */}
                {isMenuOpen && (
                    <div className="md:hidden px-4 pt-2 pb-4 space-y-2">
                        <a href="services" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Services</a>
                        <a href="how" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">How It Works</a>
                        <a href="contact" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Contact</a>
                    </div>
                )}
            </nav>
            {/* Hero Section */}
            <div className="pt-32 " //px-4 sm:px-6 lg:px-8 
            >
                <div className="text-center">
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
                        Your Local Delivery Experts
                    </h1>
                    <p className="text-xl text-sky-100 mb-8 max-w-4xl mx-auto">
                        Fast, reliable, and personalized service for all your local deliveries, transfers and daily shopping needs
                    </p>
                    <a href='#services' className="bg-white no-underline text-blue-900 px-8 py-3 rounded-full font-semibold hover:bg-sky-50 transition-colors shadow-lg">
                        Get Started Now
                    </a>
                    <div className='mt-5 w-full'>
                        <img src={log} alt='' height={50} />
                    </div>
                </div>

            </div>

            {/* Services Section */}
            <div id="services" className="py-16 bg-white/90 backdrop-blur-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl font-bold text-center text-blue-900 mb-12">Comprehensive Services Portfolio</h2>
                    <button className="text-2xl cursor-pointer rounded-3xl text-white bg-gradient-to-br from-blue-900 via-sky-600 to-sky-400 py-2 px-3 font-bold text-center mb-6">
                    <a href='https://forms.gle/HpqRoMd8WQTR9iks5' 
                    className='flex no-underline text-white justify-center align-items my-auto gap-1'>Order Services Now 
                    <ArrowRightIcon className='w-6 h-6 mt-2' />
                    </a></button>
                    <h6 className='text-center text-blue-900 mb-12'>Services available only in Prayagraj/Allahabad, Uttar Pradesh, India Right Now</h6>                    
                    {/* <div className="space-y-10 w-3/4 mx-auto"> */}
                    <div className="grid md:grid-cols-2 w-full md:w-3/4 mx-auto gap-8">
                        {[
                            {
                                icon: ShoppingCartIcon,
                                title: 'Mustard Oil',
                                text: 'Buy Mustard(Sarson) Oil and get Delivered directly to your home'
                            },
                            {
                                icon: TruckIcon,
                                title: 'Local Transfers',
                                text: 'Secure delivery of small goods, documents, groceries, and more'
                            },
                            {
                                icon: ShoppingCartIcon,
                                title: 'Daily Shopping',
                                text: 'Let our agents shop for your groceries, medicines, and essentials'
                            },
                            {
                                icon: ClipboardDocumentListIcon,
                                title: 'Personal Errands',
                                text: 'Handle your daily tasks - package pickup, dry cleaning, postal services, document processing and more'
                            }
                            // ,
                            // {
                            //     icon: HomeModernIcon,
                            //     title: 'HouseMaid Service',
                            //     text: 'Professional housemaids for cleaning, cooking, and household maintenance services'
                            // },
                            // {
                            //     icon: TruckIcon,
                            //     title: 'Dawn-to-dusk dairy service',
                            //     text: 'Fresh milk & dairy products delivered to your doorstep'
                            // },
                            // {
                            //     icon: UserGroupIcon,
                            //     title: 'HomeCare Helpers',
                            //     text: 'Dedicated helpers for laundry, utensil cleaning, and home organization'
                            // },
                            // {
                            //     icon: CreditCardIcon,
                            //     title: 'Load Services',
                            //     text: 'Handle all your bill payments, mobile recharges, ticket bookings, and financial transactions'
                            // },
                            // {
                            //     icon: ClipboardDocumentIcon,
                            //     title: 'Data Entry/Admin Support',
                            //     text: 'Comprehensive backend support including data management, documentation, and business process assistance'
                            // },
                            // {
                            //     icon: CpuChipIcon,
                            //     title: 'Technical Advice & Consults',
                            //     text: 'Expert guidance on tech solutions, IT support, and digital transformation strategies'
                            // }
                        ].map((service, idx) => (
                            <div key={idx} onClick={() => Navigate('services')} className="cursor-pointer p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow">
                                <service.icon
                                    // className="h-16 w-16 text-sky-600 mb-4"
                                    className="h-12 w-12 text-sky-600 mb-4"
                                />
                                <h3 className="text-xl font-semibold text-blue-900 mb-2">
                                    {/* <h3 className="text-3xl font-semibold text-blue-900 mb-5"> */}
                                    {service.title}</h3>
                                {/* <p className="text-xl text-gray-600"> */}
                                <p className="text-gray-600">
                                    {service.text}</p>
                            </div>
                        ))}
                    </div>
                    {/* Service Legend */}
                    <div className="mt-12 flex flex-wrap gap-4 justify-center">
                        {[
                            // { color: 'bg-sky-600', text: 'Instant Delivery (Under 2hrs)' },
                            { color: 'bg-blue-900', text: 'Home Services' },
                            { color: 'bg-green-500', text: 'Loads & Transfers' },
                            { color: 'bg-purple-500', text: 'Personal Assistance' }
                        ].map((legend, idx) => (
                            <div key={idx} className="flex items-center gap-2">
                                <div className={`w-4 h-4 ${legend.color} rounded-full`}></div>
                                <span className="text-gray-600 text-sm">{legend.text}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* How It Works Section */}
            <div id="how" className="py-16 bg-sky-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl font-bold text-center text-blue-900 mb-12">How It Works</h2>
                    <div className="grid md:grid-cols-4 gap-8">
                        {[
                            { step: '1', title: 'Place Request', text: 'Contact us via form, website, or phone' },
                            { step: '2', title: 'Agent Assignment', text: 'We assign you a personal service agent' },
                            { step: '3', title: 'Receive Service', text: 'Get updates and confirm delivery and receive service' },
                            { step: '4', title: 'Payment System', text: 'Pay during or after service completion' },
                        ].map((step, idx) => (
                            <div key={idx} onClick={() => Navigate('how')} className="cursor-pointer text-center p-6">
                                <div className="w-16 h-16 bg-sky-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4">
                                    {step.step}
                                </div>
                                <h3 className="text-xl font-semibold text-blue-900 mb-2">{step.title}</h3>
                                <p className="text-gray-600">{step.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="py-16 bg-gradient-to-r from-blue-900 to-sky-600">
                {/* <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl font-bold text-white mb-6">Ready to Experience Convenience?</h2>
                    <p className="text-sky-100 mb-8 text-xl">Join hundreds of satisfied customers today!</p>
                    <div className="flex justify-center space-x-4">
                        <a href='register' className="bg-white no-underline text-blue-900 px-8 py-3 rounded-full font-semibold hover:bg-sky-50 transition-colors">
                            Sign Up Now
                        </a>
                        <a href='contact' className="border-2 border-white no-underline text-white px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-colors">
                            Contact Us
                        </a>
                    </div>
                </div> */}
                <div className="w-full grid md:grid-cols-3 gap-8 mx-auto my-5 text-center px-4 sm:px-6 lg:px-8">
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6 text-center">About NexusAgents</h2>
                        <p className="text-sky-100 mb-8 text-xl text-justify">
                            {/* At NexusAgents, we bridge the gap between busy lives and everyday necessities. As your trusted local service partner, we specialize in secure doorstep deliveries, personalized shopping assistance, and hassle-free errand management. Our network of vetted professionals combines tech-driven efficiency with human-centric care, handling everything from urgent document transfers to meticulous grocery runs. Beyond physical tasks, we empower businesses with administrative support and tech consultations, ensuring both homes and enterprises thrive. With transparent pricing, real-time tracking, and a commitment to reliability, we transform time-consuming chores into seamless experiences. NexusAgents isn’t just a service—it’s your extended team, redefining convenience in the modern world. */}
                            We’re your hyperlocal solution hub, offering secure transfers, deliveries, personal shopping, and errand services for busy lives. With tech-driven agents and vetted pros, we simplify tasks from grocery runs to business paperwork. Trusted reliability, transparent pricing—we turn chores into effortless moments.
                        </p>
                    </div>
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6">Features</h2>
                        <ul className="list-unstyled space-y-4 text-center" aria-label="Quick links">
                            {/* <li><a href="refund" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Refund Policy</a></li> */}
                            <li><a href="terms" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Terms of Service</a></li>
                            <li><a href="privacy" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-6">Ready to Experience Convenience?</h2>
                        <p className="text-sky-100 mb-8 text-xl">Join hundreds of satisfied customers today!</p>
                        <div className="flex justify-center space-x-4">
                            {/* <a href='register' className="bg-white no-underline text-blue-900 px-8 py-3 rounded-full font-semibold hover:bg-sky-50 transition-colors">
                                Sign Up Now
                            </a> */}
                            <a href='contact' className="border-2 border-white no-underline text-white px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-colors">
                                Contact Us
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-blue-900 text-sky-100 py-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p>Copyright © 2025 NexusAgents. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
}